module.exports = __webpack_public_path__ + "static/media/orange.1f711870.svg";